 

import React, { useEffect, useState } from 'react';
import Radio from 'v3/components/Radio';

import { Col, Row } from 'react-bootstrap';

import { cooperplaceApi } from 'services/api';

import Modal from 'v3/components/Modal';
import Select from 'v3/components/Select';
import Text from 'v3/components/Text';
import Button from 'v3/components/Button';

import { useUser } from '../context';

function UpdateShippingCompany({ isOpen, onClose, shippingCompanyId }) {
  const user = useUser();
  const [shippingCompany, setShippingCompany] = useState();
  const [loading, setLoading] = useState(false);

  const [headquarter, setHeadquarter] = useState(0);

  const closeSubmit = () => {
    setShippingCompany();
    onClose();
  };

  useEffect(() => {
    const shippingCompanyData = user.data.shipping_companies?.find(
      (item) => item.id === shippingCompanyId,
    );
    if (shippingCompanyData) {
      setHeadquarter(shippingCompanyData.pivot.is_headquarter ? 1 : 0);
      setShippingCompany(shippingCompanyData);
    }
  }, [shippingCompanyId]);

  async function handleAttachShipper() {
    try {
      setLoading(true);

      await cooperplaceApi.put(`user/update-shipping-company/${user?.data?.id}`, {
        shippingCompanyId: shippingCompany.id,
        is_headquarter: headquarter,
      });

      let updatedCompanies;

      if (headquarter) {
        updatedCompanies = user.data.shipping_companies.map((sc) => ({
          ...sc,
          pivot: {
            ...sc.pivot,
            is_headquarter: sc.id === shippingCompany.id,
          },
        }));
      } else {
        updatedCompanies = user.data.shipping_companies.map((sc) =>
          sc.id === shippingCompany.id
            ? {
                ...sc,
                pivot: {
                  ...sc.pivot,
                  is_headquarter: false,
                },
              }
            : sc,
        );
      }

      user.setData({
        ...user.data,
        shipping_companies: updatedCompanies,
      });

      user.showSnackbar('Transportadora atualizada', { type: 'success' });
      closeSubmit();
    } catch (error) {
      const message = error?.response?.data?.error || 'Erro ao atualizar transportadora';
      user.showSnackbar(message, { type: 'error' });
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <Modal
        show={isOpen}
        onHide={closeSubmit}
        size="lg"
        heading={
          <Text color="dark" type="header">
            Editar Transportadora
          </Text>
        }
        body={
          <Row>
            <Col xs={12} className="d-flex flex-column align-items-center">
              <Select
                className="mt-3"
                label={
                  <Text type="label" weight="500">
                    Transportadora
                  </Text>
                }
                value={shippingCompany}
                getOptionLabel={(option) => {
                  const label = `${option.social_name} - ${option.cgccpf}`;
                  return label;
                }}
                getOptionValue={(option) => option.id}
                isDisabled
              />
            </Col>
            <Col xs={12} className="mt-3">
              <Radio.Group
                label="Tornar essa transportadora matriz"
                onChange={({ target }) => setHeadquarter(target.value)}
                value={headquarter}
                horizontal
              >
                <Radio value={1}>
                  <Text color="dark" type="label">
                    Sim
                  </Text>
                </Radio>
                <Radio value={0}>
                  <Text color="dark" type="label">
                    Não
                  </Text>
                </Radio>
              </Radio.Group>
            </Col>
            <Col className="d-flex justify-content-center">
              <Button onClick={handleAttachShipper} className="my-2" loading={loading}>
                <Text type="regular" weight="500" color="white">
                  Salvar
                </Text>
              </Button>
            </Col>
          </Row>
        }
      />
    </>
  );
}

export default UpdateShippingCompany;
